import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Events } from '../../helpers/events';

// ionic
import { ModalController } from '@ionic/angular';

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject, Subscription } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";

// providers
import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";

// models
import { Event } from "../../models/event";
import { User } from "../../models/user";


@Component({
    selector: 'app-event-detail',
    templateUrl: './event-detail.component.html',
    styleUrls: ['./event-detail.component.scss'],
})
export class EventDetailComponent implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * subscription for event changes subject
     *
     * @type {Subscription}
     */
    private subscriptionEvent: Subscription;

    /**
     * current event
     *
     * @type {User}
     */
    public user: User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;


    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;


    public loading: boolean = true;

    /**
     * profile of attendee which is presented
     *
     * @type {Participant}
     */
    @Input() block;

    /**
     * constructor
     *
     * @param pushPageService
     * @param userProvider
     * @param appEvents
     */
    constructor(
        public eventService: EventService,
        public translate: TranslateService,
        public userService: UserService,
        public overlayService: OverlayService,
        public plt: PlatformService,
        public appEvents: Events,
        public modalController: ModalController
    ) {
        // user language
        this.userLang = this.translate.currentLang;
    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        )
            .subscribe((user: User) => {
                this.user = user;

                // cancel previous subscription
                if (this.subscriptionEvent) {
                    this.subscriptionEvent.unsubscribe();
                }

                this.subscriptionEvent = this.eventService.getCurrentEvent().pipe(
                    takeUntil(this.ngUnsubscribe),
                    debounceTime(0)
                ).subscribe((event) => {
                    this.event = event;
                    if (!this.event.translate(this.userLang)[this.block.key]
                        && this.block.customLabel
                        && this.block.customLabel.translateOrNew(this.userLang).external_link) {
                        // wait for onLoad event in iframe...
                    } else {
                        this.loading = false;
                    }
                });
            });
    }

    /**
     * mark external content as loaded
     *
     * @param key
     */
    public onLoad(customLabel) {
        setTimeout(() => {
            customLabel.loadedIframe = true
            this.loading = false;
        }, 500);
    }

    /**
   * open pdf
   *
   * @param url
   */
    openPDFviaGoogleDocs(url) {
        window.open("https://docs.google.com/viewer?url=" + url, '_system');
    }

    /**
     * open external HTML page
     *
     * @param customLabel
     */
    public showExternalLink(customLabel) {


        let url = customLabel.translate(this.userLang, this.event.default_locale).external_link;

        // use google docs viewer if some document
        if (url.match(/^.*\.(doc|docx|xls|xlsx|pdf|txt)$/)) {
            this.openPDFviaGoogleDocs(url);
        } else {
            window.open(url, '_blank');

        }

    }


    close() {
        this.modalController.dismiss({ action: 'close' });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.overlayService.closeModals();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }


}
